<template>
    <img class="rt-picture"
         :src="src" :srcset="srcset"
    />
</template>

<script>
    import _ from 'lodash';

    export default {
        props: {
          'src': {
            type: String,
            default: ''
          },
          'autosize': {
            type: Boolean,
            default: true
          }
        },
        computed: {
          srcset: function (){
            const name = _.split(this.src, '.');
            if (name[1] === 'svg') return null;
            const filename_x1 = this.src;
            const filename_x2 = _.isEmpty(this.src) ? '' : `, ${name[0]}@2x.${name[1]} 2x`;
            const filename_x3 = _.isEmpty(this.src) ? '' : `,${name[0]}@3x.${name[1]} 3x`;
            return this.autosize ? `${filename_x1} ${filename_x2} ${filename_x3}` : filename_x1;
          }
        }
  }
</script>

<style scoped lang="scss">

    .rt-picture {
        display: inline-block;
        padding: 0;
        margin: 0;
        max-width: 100%;
        height: auto;
        object-fit: contain;
    }


</style>
